import { render, staticRenderFns } from "./jlPlan.vue?vue&type=template&id=0c092224&scoped=true"
import script from "./jlPlan.vue?vue&type=script&lang=js"
export * from "./jlPlan.vue?vue&type=script&lang=js"
import style0 from "./jlPlan.vue?vue&type=style&index=0&id=0c092224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c092224",
  null
  
)

export default component.exports